import { Grid, GridSpacing, Skeleton, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import useWidth, { BreakpointSizes } from '../Hooks/useWidth';
import { CAROUSEL_GRID_SIZES, getItemsSizeBySelectedBreakpoint } from './GroupedCarousel';

const useStyles = makeStyles<LoadingCardsProps>()((theme: Theme, { aspectRatio }) => ({
  cardSkeleton: {
    aspectRatio: aspectRatio,
    borderRadius: theme.shape.borderRadius,
  },
}));

export type LoadingCardsProps = {
  gridSizes?: BreakpointSizes;
  spacing?: GridSpacing;
  aspectRatio?: number;
};

const LoadingCards = ({ gridSizes, spacing = 2, aspectRatio = 0.791 }: LoadingCardsProps) => {
  const { classes } = useStyles({ gridSizes, spacing, aspectRatio });
  const { activeBreakpoint } = useWidth();
  const defaultGridProps: BreakpointSizes = { ...CAROUSEL_GRID_SIZES, ...gridSizes };
  const cardsLength: number = getItemsSizeBySelectedBreakpoint(defaultGridProps, activeBreakpoint);

  return (
    <Grid container spacing={spacing}>
      {Array(cardsLength)
        .fill('')
        .map((_emptyItem, index) => (
          <Grid key={`skeleton-${index}`} size="grow">
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              className={classes.cardSkeleton}
            />
          </Grid>
        ))}
    </Grid>
  );
};

export default LoadingCards;
